const React = require('react');

const Node = ({ node }) => (
  <li key={node.id}>
    <a className={node.selected ? 'post-selected' : ''} href={node.path}>{node.title}</a>
  </li>
);

module.exports = Node;
